import { authFetch, API_URL, clearAuthSession, getAuthHeaders } from "../../utils/auth";

const OVERVIEW_URL = `${API_URL}/admin/overview/`;

function headers() {
  return {
    Accept: "application/json",
    ...getAuthHeaders(),
  };
}

async function parse(response) {
  const contentType = response.headers.get("content-type") || "";
  const data = contentType.includes("application/json") ? await response.json() : { detail: "The request could not be completed." };
  if (response.status === 401) clearAuthSession();
  if (!response.ok) {
    const error = new Error(data?.detail || data?.message || "Admin overview could not be loaded.");
    error.status = response.status;
    error.data = data;
    throw error;
  }
  return data;
}

export async function fetchAdminOverview({ search = "", signal } = {}) {
  const params = new URLSearchParams();
  if (search) params.set("search", search);
  const query = params.toString();
  return parse(await authFetch(query ? `${OVERVIEW_URL}?${query}` : OVERVIEW_URL, { headers: headers(), signal }));
}
